import axios from "./axios";
import config from "../config";

function listZhanhui(params) {
    return axios({
        url: config.backendUrl + 'zhanhui',
        method: 'GET',
        params: params
    })
}

function getZhanhuiProvinceStat(params) {
    return axios({
        url: config.backendUrl + 'zhanhui/province-stat',
        method: 'GET',
        params
    })
}

function getZhanhuiCityStat(params) {
    return axios({
        url: config.backendUrl + 'zhanhui/city-stat',
        method: 'GET',
        params
    })
}

function getZhanhuiById(id) {
    return axios({
        url: config.backendUrl + 'zhanhui/'+id,
        method: 'GET',
    })
}

function listZhanhuiNews(params) {
    return axios({
        url: config.backendUrl + 'news/zhanhui-news',
        method: 'GET',
        params
    })
}
function listChangguanNews(params) {
    return axios({
        url: config.backendUrl + 'news/changguan-news',
        method: 'GET',
        params
    })
}
function getChangguanById(id) {
    return axios({
        url: config.backendUrl + 'changguan/'+id,
        method: 'GET',
    })
}
function getChangguanByName(name) {
    return axios({
        url: config.backendUrl + 'changguan/get-by-name',
        method: 'GET',
        params:{name}
    })
}
function getZhanhuiMjStat(params) {
    return axios({
        url: config.backendUrl + 'zhanhui/mj-stat',
        method: 'GET',
        params
    })
}
function getZhanhuiSshyStat(params) {
    return axios({
        url: config.backendUrl + 'zhanhui/sshy-stat',
        method: 'GET',
        params
    })
}
function getZhanhuiJbzqStat(params) {
    return axios({
        url: config.backendUrl + 'zhanhui/jbzq-stat',
        method: 'GET',
        params
    })
}
function listChangguan(params) {
    return axios({
        url: config.backendUrl + 'changguan',
        method: 'GET',
        params: params
    })
}
function getChangguanProvinceStat(year) {
    return axios({
        url: config.backendUrl + 'changguan/province-stat',
        method: 'GET',
        params:{year}
    })
}

function getChangguanCityStat(year,province) {
    return axios({
        url: config.backendUrl + 'changguan/city-stat',
        method: 'GET',
        params:{year,province}
    })
}
function getChangguanMjStat() {
    return axios({
        url: config.backendUrl + 'changguan/mj-stat',
        method: 'GET',
    })
}
function listChangguanKzl(startDate, endDate, limit) {
    return axios({
        url: config.backendUrl + 'changguan/changguan-kzl',
        method: 'GET',
        params:startDate, endDate, limit
    })
}
function listAreaKzl(startDate, endDate) {
    return axios({
        url: config.backendUrl + 'changguan/area-kzl',
        method: 'GET',
        params:startDate, endDate
    })
}
function statChangguanByZhanhuiCount(limit) {
    return axios({
        url: config.backendUrl + 'changguan/stat-by-zhanhui-count',
        method: 'GET',
        params:{limit}
    })
}
function statChangguanByZhanhuiMj(limit) {
    return axios({
        url: config.backendUrl + 'changguan/stat-by-zhanhui-mj',
        method: 'GET',
        params:{limit}
    })
}
function listQaData(params) {
    return axios({
        url: config.backendUrl + 'news/qa',
        method: 'GET',
        params
    })
}
function listFunding(params) {
    return axios({
        url: config.backendUrl + 'news/funding',
        method: 'GET',
        params
    })
}
function listPenalty(params) {
    return axios({
        url: config.backendUrl + 'news/penalty',
        method: 'GET',
        params
    })
}
function listBidding(params) {
    return axios({
        url: config.backendUrl + 'news/bidding',
        method: 'GET',
        params
    })
}
function listHzReports(params) {
    return axios({
        url: config.backendUrl + 'news/hz-reports',
        method: 'GET',
        params
    })
}
function listZcwj(params) {
    return axios({
        url: config.backendUrl + 'news/zcwj',
        method: 'GET',
        params
    })
}
function getZhanhuiTotalStat(params) {
    return axios({
        url: config.backendUrl + 'zhanhui/total-stat',
        method: 'GET',
        params
    })
}
function getChangguanTotalStat() {
    return axios({
        url: config.backendUrl + 'changguan/total-stat',
        method: 'GET',
    })
}
function listAllIndustries() {
    return axios({
        url: config.backendUrl + 'industries',
        method: 'GET',
    })
}
function getZhanhuiJbkssjYearStat(params) {
    return axios({
        url: config.backendUrl + 'zhanhui/year-stat',
        method: 'GET',
        params
    })
}
function getZhanhuiDwStat(params) {
    return axios({
        url: config.backendUrl + 'zhanhui/dw-stat',
        method: 'GET',
        params
    })
}
function getZhanhuiAreaMonthStat(params) {
    return axios({
        url: config.backendUrl + 'zhanhui/area-month-stat',
        method: 'GET',
        params
    })
}
function listMof(params) {
    return axios({
        url: config.backendUrl + 'news/mof',
        method: 'GET',
        params
    })
}
function getChangguanMjStatByArea() {
    return axios({
        url: config.backendUrl + 'changguan/mj-stat-by-area',
        method: 'GET'
    })
}
function getChangguanCountStatByArea() {
    return axios({
        url: config.backendUrl + 'changguan/count-stat-by-area',
        method: 'GET'
    })
}
function getChangguanMjStatByCity() {
    return axios({
        url: config.backendUrl + 'changguan/mj-stat-by-city',
        method: 'GET'
    })
}
function getChangguanCountStatByCity() {
    return axios({
        url: config.backendUrl + 'changguan/count-stat-by-city',
        method: 'GET'
    })
}
function listChangguanZhanhuiInfo(params) {
    return axios({
        url: config.backendUrl + 'changguan/changguan-zhanhui-info',
        method: 'GET',
        params
    })
}
function listChangguanZhanhuiInfo1(params) {
    return axios({
        url: config.backendUrl + 'changguan/changguan-zhanhui-info',
        method: 'GET',
        params
    })
}
function listHuixiaoerChangguan(params) {
    return axios({
        url: config.backendUrl + 'news/hxe-changguan',
        method: 'GET',
        params
    })
}
function getHuixiaoerChangguanById(id) {
    return axios({
        url: config.backendUrl + 'news/hxe-changguan/'+encodeURIComponent(id),
        method: 'GET',
    })
}
function getZhanhuiJbcgStat(params) {
    return axios({
        url: config.backendUrl + 'zhanhui/jbcg-stat',
        method: 'GET',
        params
    })
}
function listChangguanMonthlyKzl(cgid,startDate,endDate) {
    return axios({
        url: config.backendUrl + 'changguan/'+ cgid + '/monthly-kzl',
        method: 'GET',
        params:{startDate,endDate}
    })
}
function getAttachmentUrl(name){
    return name?config.gatewayUrl + 'file/download?name=' + encodeURIComponent(name):null
}
function listTjjNews(params) {
    return axios({
        url: config.backendUrl + 'news/tjj',
        method: 'GET',
        params
    })
}
function listCompany(params) {
    return axios({
        url: config.backendUrl + 'company',
        method: 'GET',
        params: params
    })
}
function getTagStat(params) {
    return axios({
        url: config.backendUrl + 'company/tag-stat',
        method: 'GET',
        params
    })
}
function listEntity(params) {
    return axios({
        url: config.backendUrl + 'entity',
        method: 'GET',
        params: params
    })
}
function listDocument(params) {
    return axios({
        url: config.backendUrl + 'document',
        method: 'GET',
        params: params
    })
}
function downLoad(name){
    return axios({
        url: name?config.gatewayUrl + 'file/download?name=' + encodeURIComponent(name):null,
        method: 'GET',
        responseType: 'blob', // 重要，设置响应类型为 Blob
    })
}
export default {
    listZhanhui,
    getZhanhuiProvinceStat,
    getZhanhuiCityStat,
    getZhanhuiById,
    listZhanhuiNews,
    listChangguanNews,
    getChangguanById,
    getChangguanByName,
    getZhanhuiMjStat,
    getZhanhuiSshyStat,
    getZhanhuiJbzqStat,
    listChangguan,
    getChangguanProvinceStat,
    getChangguanCityStat,
    getChangguanMjStat,
    listChangguanKzl,
    listAreaKzl,
    statChangguanByZhanhuiCount,
    statChangguanByZhanhuiMj,
    listQaData,
    listFunding,
    listPenalty,
    listBidding,
    listHzReports,
    listZcwj,
    getZhanhuiTotalStat,
    getChangguanTotalStat,
    listAllIndustries,
    getZhanhuiJbkssjYearStat,
    getZhanhuiDwStat,
    getZhanhuiAreaMonthStat,
    listMof,
    getChangguanMjStatByArea,
    getChangguanCountStatByArea,
    getChangguanMjStatByCity,
    getChangguanCountStatByCity,
    listChangguanZhanhuiInfo,
    listChangguanZhanhuiInfo1,
    listHuixiaoerChangguan,
    getHuixiaoerChangguanById,
    getZhanhuiJbcgStat,
    listChangguanMonthlyKzl,
    getAttachmentUrl,
    listTjjNews,
    listCompany,
    getTagStat,
    listEntity,
    listDocument,
    downLoad
}
